import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { TypedMemo } from '../../common/types';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { Panel, PanelBody, PanelHead } from '../components/primitives/Panel';
import { SMLButton } from '../components/primitives/SMLButton';

const messages = defineMessages({
  title: { id: 'app.sml.watchlist.firstStep.title', defaultMessage: 'Start your watchlist' },
  text: {
    id: 'app.sml.watchlist.firstStep.text',
    defaultMessage:
      'Follow your own artist page and 3 artists like you. Then this page shows what goes up and what moves for them.',
  },
  search: { id: 'app.sml.watchlist.firstStep.search', defaultMessage: 'Search artists' },
});

/**
 * The first step of an empty Watchlist (QA 2026-10-24 F20). With no follow, the trends cards
 * showed tracks of other people, which looked like data of another account. This card takes their
 * place until the workspace follows something.
 */
const WatchlistFirstStepComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  return (
    <Panel className="mb-4" data-testid="watchlist-first-step">
      <PanelHead title={intl.formatMessage(messages.title)} />
      <PanelBody stack>
        <p className="mb-0">{intl.formatMessage(messages.text)}</p>
        <div>
          <SMLButton
            variant="primary"
            icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            onClick={() => router.push(SMLRoutes.browse)}
          >
            {intl.formatMessage(messages.search)}
          </SMLButton>
        </div>
      </PanelBody>
    </Panel>
  );
};

export const WatchlistFirstStep = TypedMemo(WatchlistFirstStepComponent);
